import http from "@/services/http";

/**
 * Lista as avaliações de sono de um paciente (tabela patient_sleep_assessments),
 * mais recente primeiro.
 *
 * @param {number|string} patientId
 * @returns {Promise<object[]>}
 */
export async function getSleepByPatient(patientId) {
  const { data } = await http.get(
    `/api/patient-sleep-assessments/get-by-patient/${patientId}`,
  );
  return data?.status === "success" ? data.data || [] : [];
}

/**
 * Cria uma avaliação de sono.
 * @param {number|string} patientId
 * @param {object} payload { quality?, has_weekday_routine?, weekend_routine?, has_apnea?, assessed_at?, notes? }
 */
export function createSleep(patientId, payload) {
  return http.post("/api/patient-sleep-assessments/create", {
    patient_id: patientId,
    ...payload,
  });
}

/**
 * Atualiza uma avaliação de sono existente.
 */
export function updateSleep(id, payload) {
  return http.put(`/api/patient-sleep-assessments/update/${id}`, payload);
}

/**
 * Remove uma avaliação de sono (soft delete).
 */
export function deleteSleep(id) {
  return http.delete(`/api/patient-sleep-assessments/delete/${id}`);
}
